export enum ConfirmCodeType {
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  SIGN_UP = "SIGN_UP",
  DELETE_ACCOUNT = "DELETE_ACCOUNT",
}

export enum UserRolesEnum {
  SUPER_ADMIN = "SUPER_ADMIN",
  PLATFORM_ADMIN = "PLATFORM_ADMIN",
  USER = "USER",
  DISTRICT_ADMIN = "DISTRICT_ADMIN",
  DISTRICT_STANDARD_USER = "DISTRICT_STANDARD_USER",
  DISTRICT_LIMITED_USER = "DISTRICT_LIMITED_USER",
}

export enum UserStatusesEnum {
  ACTIVE = "active",
  INACTIVE = "inactive"
}

export enum UserRegistrationMethodEnum {
  EMAIL = "EMAIL",
  GOOGLE = "GOOGLE",
  MICROSOFT = "MICROSOFT",
}
